// export const BASE_URL = "http://localhost:5000/educator-93566/us-central1/app"
export const BASE_URL = " https://us-central1-educator-93566.cloudfunctions.net/app"

// export const baseAxios = require('axios-base-url')(baseUrl)


// WEBPACK FOOTER //
// ./src/services/config.js